import React from 'react';
import styled from 'styled-components/macro';
import { DeviceSize } from '../../components/basic/DeviceSize';

const Grid = styled.div`
  column-count: 3;
  column-gap: 20px;

  @media ${DeviceSize.desktopM} {
    column-count: 2;
  }

  @media ${DeviceSize.desktopS} {
    column-count: 1;
  }

  > div {
    margin-bottom: 20px;
  }
`;

const CardGrid: React.FunctionComponent = ({ children }) => {
  return <Grid>{children}</Grid>;
};

export default CardGrid;
